import React from 'react';
import { createPortal } from 'react-dom';
import { AudioWaveform } from 'lucide-react';
import { TabBtn } from '../../shared/ui/tab-btn';
import { useFlyoutPosition } from '../../shared/hooks/use-flyout-position';
import { dimensions } from '../../theme';
import { useSoundPanelState } from '../hooks/use-sound-panel-state';
import { SoundPanelContent } from './sound-panel-content';

/**
 * Sound panel shown from the editor sidebar.
 * Keeps its state between openings while mounting the panel content only when visible.
 */
export const SoundPanel: React.FC = () => {
  const { open, triggerRef, pos, toggle } = useFlyoutPosition('sound');
  const state = useSoundPanelState();

  return (
    <div ref={triggerRef} data-panel-id='sound' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <TabBtn
        panelId='sound'
        onClick={toggle}
        label='Sonido'
        icon={<AudioWaveform size={dimensions.size.iconLg} />}
        active={open}
      />
      {open && pos && createPortal(<SoundPanelContent pos={pos} state={state} />, document.body)}
    </div>
  );
};
